// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Zahlungsdatei } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGeneriereZahlungsdatei(): (
  zahllaufId: string,
  requestBody: { kontoId: string }
) => Promise<Zahlungsdatei> {
  const getAPI = useGetApi();
  return useCallback(
    async (zahllaufId, requestBody) =>
      (await getAPI()).zahllaeufe.generiereZahlungsdatei({
        zahllaufId,
        requestBody,
      }),
    [getAPI]
  );
}
